import {Observable} from 'rxjs/Observable'
import {DataService} from 'core/data/service'

export class PbmZicardService extends DataService {
    constructor(){
      super()
    }

    // @Path("/zicard/consulta-preco") (1)
    // @Path("/zicard/pre-autorizacao")(2)

    consultaPreco(preAutorizacao){

      const data = this.buildPreAutorizacao(preAutorizacao);

      const options = {
          method: 'POST',
          url: "/pbm/zicard/consulta-preco",
          data: data
      }

      return Observable
              .fromPromise(super.request(options));
    }


    preAutorizacao(preAutorizacao){

      const data = this.buildPreAutorizacao(preAutorizacao);

      const options = {
          method: 'POST',
          url: "/pbm/zicard/pre-autorizacao",
          data: data
      }
      
      return Observable
              .fromPromise(super.request(options));
    }


    // Integer canalVenda; // required
    // Long codigoFilial; // required
    // String tipoPrograma; // required - tipos aceitaveis: I-Industria ou C- Convenio
    // String usuario; // required
    // String cnpjOrigem; // required
    // String cpfBeneficiario; // required
    // String cpfAtendimento; // required
    // String cartaoBeneficiario; // required
    // String codigoPrograma; // required
    // List<PreAutorizacaoItemRequest> itens; // required
    // Long sequenciaPrograma;
    // Long codigoConvenio;
    // Long codigoAdminConvenio;
    // String nsuPreAutorizacao;
    // String identificadorTransacao;
    // fatorConversaoAutorizado


    buildPreAutorizacao(data) {
      let preAutoriazacao = {
        "cartaoBeneficiario": data.nroCartao,
        "cpfBeneficiario": data.nroCpf,
        "codigoPrograma": data.sequenciaPrograma,
        "codigoConvenio": data.codigoConvenio,
        "codigoAdminConvenio": data.codigoAdminConvenio,
        "sequenciaPrograma": data.sequenciaPrograma,
        "fatorConversaoAutorizado": data.fatorConversaoAutorizado,
        "itens": [
          {
            "codigoItem": data.item,
            "quantidadeSolicitada": data.quantidadeSolicitada
          }
        ]
      }
      return preAutoriazacao;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/modal/modal-pbm/pbm-zicard/pbm-zicard.service.js